import { render, staticRenderFns } from "./AnimaIcon.vue?vue&type=template&id=5a184944&"
import script from "./AnimaIcon.vue?vue&type=script&lang=js&"
export * from "./AnimaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports